import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { CustomAddButton } from "./CustomAddButton";

export const CustomGridToolbar = ({
  handleClickOpen,
}: {
  handleClickOpen: () => void;
}) => {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <CustomAddButton handleClick={handleClickOpen} />
    </GridToolbarContainer>
  );
};
